import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'DELETE_DELIVERY_VOUCHER_',
  }
);

export interface DeleteDeliveryVoucherState {
  id: number | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface DeleteDeliveryVoucherRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: DeleteDeliveryVoucherState = {
  id: null,
  loading: false,
  errorMessage: null,
};

const request = (state: DeleteDeliveryVoucherState, action: DeleteDeliveryVoucherRequestAction) =>
  update(state, {
    id: { $set: action.id },
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: DeleteDeliveryVoucherState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const failure = (state: DeleteDeliveryVoucherState, action: FailureAction) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: DeleteDeliveryVoucherState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const deleteDeliveryVoucher = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const DeleteDeliveryVoucherTypes = Types;
export const DeleteDeliveryVoucherActions = Creators;
